export default __webpack_public_path__ + "static/media/certificate2-2.7d52ea81.png";